import { Button, Input, Spinner } from "@public/ui-toolkit";
import { Col, Empty, Row, Spin, Modal, Form, Upload, Popconfirm, Dropdown } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createAllocatorNetworks, deleteAllocatorNetwork, getAllocatorContacts, getAllocatorUsers, importAllocatorContacts, sendInvitationEmail, updateAllocatorNetworks, } from "./actions";
import { getNumberWithUnit } from "@hedgefund/shared";
import { LoadingOutlined } from '@ant-design/icons';
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router";
import { debounce } from "lodash";
import { createRoom } from "../FundDetail/actions";
import { alertService } from "@hedgefund/shared/src/Alert";


// const customStyles = {
//   control: (provided, state) => ({
//     ...provided,
//     width: "180px",
//     minHeight: "50px",
//     padding: 4,
//   }),
// };

const networkStatus = [
  {
    name: "Pending",
    id: 0
  },
  {
    name: "Accepted",
    id: 1
  },
  {
    name: "Rejected",
    id: 2
  },
  {
    name: "Blocked",
    id: 3
  }
]
const RoomType = [
  {
    id: 0,
    name: "Private"
  },
  {
    id: 1,
    name: "Group"
  }
]
const AllocatorContact = ({ }) => {

  const [searchResult, setSearchResult] = useState("");
  const [tenantId, setTenantId] = useState(null);
  const [chatLoading, setChatLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [imageUrl, setImageUrl] = useState();

  var history = useHistory();
  const AllocatorNetworkState = useSelector((state) => state.AllocatorContactStore)
  const { allocatorUsers, allocatorContacts, loading, emailLoading, userLoading,
    currentPage, perPage, totalPages, contactLoading } = AllocatorNetworkState;
  const items = [
    {
      key: 0,
      label: "Allocator Chat",
    },
    ...allocatorUsers?.map((data, index) => {
      return ({
        key: data.id,
        label: data?.fullName,
      })
    })
  ];
  const onCloseModal = () => setOpen(false);
  const showModal = () => setOpen(true);

  const dispatch = useDispatch();
  useEffect(() => {
    const user = jwt_decode(localStorage.getItem("token") ? localStorage.getItem("token") : sessionStorage.getItem("token"));
    setTenantId(user?.["http://www.aspnetboilerplate.com/identity/claims/tenantId"]);
    AllocatorContactList(1)
  }, [dispatch])


  const AllocatorContactList = (page = currentPage + 1, value) => {
    dispatch(getAllocatorContacts({
      keyword: value,
      page: page,
      perPage: perPage,
      sortBy: 1,
      sortByColumn: "CreationTime"
    }));
  }
  const handleSearch = debounce((text) => {
    setSearchResult(text);
    AllocatorContactList(1, text);
  }, 1500);
  // const onClickTab = (key) => {
  //   setTabType(key);
  //   AllocatorNetworkList(1, key);
  // }

  function handleScroll() {
    var reachedBottom1 = window.scrollY + window.innerHeight > document.documentElement.scrollHeight * 0.9;
    if (!contactLoading && totalPages > currentPage && reachedBottom1) {
      AllocatorContactList();
    }
  }
  useEffect(() => {
    window.addEventListener("scroll", handleScroll,);
    return () => window.removeEventListener("scroll", handleScroll);
  }, [contactLoading]);

  const joinChatRoom = (body) => {
    setChatLoading(true);
    dispatch(
      createRoom(body, (roomId) => {
        setChatLoading(false);
        history.push(`/chat?identifier=${roomId}&type=0`);
      })
    );
  }

  const onContactClick = ({ key }) => {
    const body = {
      tenantId,
      type: key === "0" ? RoomType[1].id : RoomType[0].id,
      ...(key !== "0" && { userId: key }),
    };
    joinChatRoom(body);
  }
  const handleChange = (event) => {
    let fileList = event.fileList[0]
    setImageUrl(fileList);
  };
  const onSuccess = () => {
    onCloseModal();
    alertService.success("Import Allocator Contacts successfully!", { autoClose: true });
  }
  const importContacts = () => {
    const formData = new FormData();
    if (imageUrl) {
      formData.append('file', imageUrl?.originFileObj);
      dispatch(importAllocatorContacts(formData, onSuccess));
    }
  }
  const onSuccessEmail = () => {
    alertService.success("Send Invitation email successfully!", { autoClose: true });
  }
  const sendAllocatorInvitationEmail = (id) => {
    dispatch(sendInvitationEmail(id, onSuccessEmail))
  }
  const createNetwork = (status, receiverId) => {
    const Obj = {
      status: status,
      receiverId: receiverId
    }
    dispatch(createAllocatorNetworks(Obj));
  }
  const updateNetwork = (status, receiverId, id) => {
    const Obj = {
      id: id,
      status: status,
      receiverId: receiverId
    }
    dispatch(updateAllocatorNetworks(Obj))
  }

  const deleteNetwork = (id) => {
    dispatch(deleteAllocatorNetwork(id));
  }

  return (

    (chatLoading === true) ?
      (<main className="main-doc">
        <div className="main-inner">
          <Row>
            <Col span={24} style={{ textAlign: "center" }}>
              <Spin />
            </Col>
          </Row>
        </div>
      </main>)
      :
      (<main className="main-doc">
        <div className="main-inner">
          <div className="col-lg-12 p-4 mt-1">
            {/* border: "1px solid gray", borderRadius: "1%", */}
            <Row gutter={[36, 36]} style={{ paddingLeft: "18px", paddingRight: "18px" }}>
              <Col span={24} className="bg-white p-3">
                <div className="mt-3">
                  <h6 className="p-1">{"Allocator Contacts"}</h6>
                  <Row gutter={[24, 24]}>
                    <Col span={21}>
                      <Input
                        placeholder="Search"
                        label="Search"
                        type="text"
                        onChange={(e) => {
                          handleSearch(e.target.value);
                        }}
                      />
                    </Col>
                    <Col span={3}>
                      <Button
                        btnName={"Import Allocator Contacts"}
                        btnType="primary"
                        btnStyle={{ height: "50px" }}
                        onClick={showModal}
                      // iconClass="fa fa-check-square mr-1"
                      />
                    </Col>
                  </Row>
                  <p style={{ color: "gray" }}>Showing Results For Allocator Contacts</p>
                </div>
                <Row gutter={[24, 24]} >
                  {!contactLoading ? (
                    <>
                      {allocatorContacts?.length > 0 ? (
                        allocatorContacts?.map((item) => {
                          return (
                            <Col span={6} className="mb-3">
                              <div className="hf-card2" >
                                <div
                                  // onClick={() => allocatorProfile(item.id)}
                                  className="hf-card2-banner search-fund-card "
                                  style={{ cursor: "pointer" }}
                                >
                                  <img
                                    style={{ width: "100%", height: "150px" }}
                                    src={item?.profileImage ? item?.profileImage : "/assets/images/bg1.png"}
                                    className="company-banner-img "
                                    alt="..."
                                  />
                                </div>
                                <div className="hf-card-body p-3" style={{ textAlign: "center" }}>
                                  <ul className="extra-info mt-2">
                                    <li style={{ height: "35px" }}>
                                      <span className="text-dark" style={{ fontSize: "14px", fontWeight: "600", cursor: "pointer" }}>
                                        {item?.name}
                                      </span>
                                    </li>
                                    <li style={{ height: "35px" }}>
                                      <i className="fa fa-map-marker mr-1"></i>
                                      <span className="text-blue">
                                        {item?.address ? item?.address?.substring(0, 60) + " ...." : "N/A"}
                                      </span>
                                    </li>
                                    <li style={{ height: "35px" }}>
                                      <i className="fa fa-map-marker mr-1"></i>
                                      <span className="text-blue">
                                        {item?.emailAddress ? item?.emailAddress : "N/A"}
                                      </span>
                                    </li>
                                    <li>
                                      <span class="badge badge-info p-1 mr-2 ">AUM: {item?.aum ? getNumberWithUnit(item?.aum) : "N/A"} </span>
                                      <span class="badge badge-secondary p-1 ">Phone :  {item?.phoneNumber ? item?.phoneNumber : "N/A"}</span>
                                    </li>
                                  </ul>
                                </div>
                                <div className="hf-card-footer">
                                  <div className="row" style={{ height: '50px' }}>
                                    {item?.externalAllocatorId ? (
                                      <>
                                        {(() => {
                                          if (networkStatus[0].id === item.recieverNetwork?.status) {
                                            return (
                                              <Row>
                                                <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <Popconfirm
                                                    title={item.name}
                                                    description="Are you sure to cancel it?"
                                                    onConfirm={() => deleteNetwork(item?.recieverNetwork?.id)}
                                                  >
                                                    <button className="border-0 bg-transparent p-0 btn-fund-card" >
                                                      <i className="fa fa-plus mr-1" style={{ color: "white" }} ></i>
                                                      Pending
                                                    </button>
                                                  </Popconfirm>
                                                </Col>
                                              </Row>
                                            )
                                          } else if (networkStatus[0].id === item.senderNetwork?.status) {
                                            return (
                                              <Row>
                                                <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <button
                                                    className="border-0  p-0 btn-fund-card"
                                                    onClick={() => updateNetwork(networkStatus[1].id, item.senderNetwork.senderId, item?.senderNetwork?.id)}
                                                  >
                                                    <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                                    Accept
                                                  </button>
                                                </Col>
                                                <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <button className="border-0  p-0 btn-fund-card"
                                                    onClick={() => deleteNetwork(item?.senderNetwork?.id)}
                                                  >
                                                    <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                                    Reject
                                                  </button>
                                                </Col>
                                              </Row>
                                            )
                                          } else if (networkStatus[1].id === item.recieverNetwork?.status || networkStatus[1].id === item.senderNetwork?.status) {
                                            return (
                                              <Row>
                                                <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <Popconfirm
                                                    // title={item.name}
                                                    title={<div><p>{`Are you sure you want to remove`}</p><p>{`${item.name} as a connection?`}</p></div>}
                                                    onConfirm={() => deleteNetwork(item?.recieverNetwork !== null ? item?.recieverNetwork?.id : item?.senderNetwork?.id)}
                                                    okText={"Remove Connection"}
                                                  >
                                                    <button className="border-0 bg-transparen        t p-0 btn-fund-card">
                                                      <i className={"fa fa-plus-square mr-1"} style={{ color: "white" }}></i>
                                                      Connected
                                                    </button>
                                                  </Popconfirm>
                                                </Col>
                                                <Col span={12} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <Dropdown
                                                    menu={{ items, onClick: onContactClick }}
                                                    onOpenChange={() => {
                                                      setTenantId(item?.externalAllocatorId);
                                                      dispatch(getAllocatorUsers(item?.externalAllocatorId));
                                                    }}>
                                                    <button className="border-0 bg-transparent p-0 btn-fund-card" onClick={(e) => e.preventDefault()}>
                                                      {(userLoading && tenantId == item?.id) ?
                                                        <Spin indicator={<LoadingOutlined style={{ fontSize: 18, color: "white" }} />} /> :
                                                        <i className={"fa fa-plus-square mr-1"} style={{ color: "white" }}></i>
                                                      }
                                                      Message
                                                    </button>
                                                  </Dropdown>
                                                </Col>
                                              </Row>
                                            )
                                          } else if (item.recieverNetwork === null || item.senderNetwork?.status === null) {
                                            return (
                                              <Row>
                                                <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <button
                                                    className="border-0  p-0 btn-fund-card"
                                                    onClick={() => createNetwork(networkStatus[0].id, item.id)}
                                                  >
                                                    <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                                    Connect
                                                  </button>
                                                </Col>
                                              </Row>
                                            )
                                          } else if (networkStatus[3].id === item.senderNetwork?.status) {
                                            return (
                                              <Row>
                                                <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }} >
                                                  <button
                                                    className="border-0 p-0 btn-fund-card"
                                                    onClick={() => updateNetwork(networkStatus[1].id, item?.senderNetwork?.receiverId, item.id)}
                                                  >
                                                    <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                                    Blocked
                                                  </button>
                                                </Col>
                                              </Row>
                                            )
                                          }
                                        })()}
                                      </>
                                    ) : (
                                      <Row>
                                        <Col span={24} style={{ backgroundColor: "#1c507d", color: "white" }}>
                                          <button
                                            className="border-0  p-0 btn-fund-card"
                                            onClick={() => sendAllocatorInvitationEmail(item?.id)}
                                          >
                                            {emailLoading && item.id ? (
                                              <Spinner />
                                            ) : (
                                              <>
                                                <i className="fa fa-plus mr-1" style={{ color: "white" }}></i>
                                                {"Invite"}
                                              </>
                                            )}
                                          </button>
                                        </Col>
                                      </Row>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </Col>
                          )
                        })
                      ) : (
                        <Row style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                          <Col span={24} >
                            <Empty />
                          </Col>
                        </Row>
                      )}
                    </>
                  ) : (
                    <Col span={24} style={{ textAlign: "center" }}>
                      <Spin />
                    </Col>
                  )}
                </Row>
              </Col>
              <Modal
                title={"Import Allocator Contacts"}
                open={open}
                onOk={importContacts}
                confirmLoading={loading}
                onCancel={onCloseModal}
                okText="Import Contacts"
                closable={false}
              >
                <>
                  <Form
                    name="basic"
                    style={{ textAlign: "center" }}
                    layout="vertical"
                    labelCol={{ span: 8 }}
                    wrapperCol={{ span: 24 }}
                    initialValues={{ remember: true }}
                    autoComplete="off"
                  >
                    <Form.Item
                      label="Choose a file"
                      name="file"
                      rules={[{ required: true, message: "Please upload your file!" }]}
                    >
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        onChange={handleChange}
                      >
                        {imageUrl ? (
                          <i class="fa fa-file-excel-o" style={{ fontSize: "75px", color: "#3aad9e" }} aria-hidden="true"></i>
                        ) : (
                          "Upload"
                        )}
                      </Upload>
                      <p>{imageUrl?.name}</p>
                    </Form.Item>
                  </Form>
                </>
              </Modal>
            </Row>
          </div>
        </div>
      </main>)

  );
};

export default AllocatorContact;
